import React, { useEffect } from "react";
import Header from "./Header";
import { Switch, Route } from "react-router-dom";
import App from "../../Screens/App";
import Builds from "../../Screens/Builds";
import ServiceList from "../../Screens/ServiceList";
import ServiceDetail from "../../Screens/ServiceDetail";
import ConfigurationCheck from "../../Screens/ConfigurationCheck";
import Broker from "../../Screens/Broker";
import Select from "../../Screens/Select";

export default function Layout() {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const isRussian = window.location.pathname.startsWith("/ru");

  if (isRussian && !isLoggedIn)
    return (
      <div className="app">
        <div>
          <form>
            <div
              style={{
                maxWidth: 600,
                margin: "100px auto",
                textAlign: "center",
                border: "1px solid #ccc",
                padding: 20,
                borderRadius: 4,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              <h2>Пожалуйста, войдите, чтобы продолжить</h2>
              <div
                style={{
                  marginBottom: 10,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 10,
                }}
              >
                <label>Имя пользователя:</label>
                <input
                  type="text"
                  name="username"
                  required
                  style={{ border: "1px solid #ccc", padding: "4px" }}
                />
              </div>
              <div
                style={{
                  marginBottom: 10,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 10,
                }}
              >
                <label>Пароль:</label>
                <input
                  type="password"
                  name="password"
                  required
                  style={{ border: "1px solid #ccc", padding: "4px" }}
                />
              </div>
              <div>
                <button
                  type="submit"
                  style={{
                    marginTop: 16,
                    padding: "6px 20px",
                    fontSize: 16,
                    cursor: "pointer",
                    border: "none",
                    backgroundColor: "#007BFF",
                    color: "#fff",
                    borderRadius: 4,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    const username = e.target.form.username.value;
                    const password = e.target.form.password.value;

                    if (username === "saxdorru" && password === "saxdorru") {
                      localStorage.setItem("isLoggedIn", "true");
                      window.location.reload();
                    } else {
                      alert("Неверное имя пользователя или пароль.");
                    }
                  }}
                >
                  Войти
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );

  return (
    <div className="app">
      <Header />

      <Switch>
        <Route path="/:lang/build/:slug/:number" exact component={App} />
        <Route path="/:lang/build/:slug" exact component={App} />
        <Route path="/:lang/builds" exact component={Builds} />
        <Route path="/:lang/service" exact component={ServiceList} />
        <Route path="/:lang/service/:id" exact component={ServiceDetail} />
        <Route
          path="/:lang/configuration/:id"
          exact
          component={ConfigurationCheck}
        />
        <Route path="/:lang/account" exact component={Broker} />
        <Route path="/:lang" exact component={Select} />
        <Route path="/" exact component={Select} />
      </Switch>
    </div>
  );
}
